import {ITranslationService} from './translation.service.interface';
import {ServiceBase} from '../ServiceBase';
import {Check} from "@sparkware/app-utils";
import {TextTranslation} from "./text-translation";

export class TranslationService extends ServiceBase implements ITranslationService {

  get langData(): any {
    return this.services.language.translatedTexts;
  }

  translate(key: string, parameters?: any): string {
    try {
      let translatedPhrase = '';

      if (this.langData && key !== '') {
        if (this.langData[key]) {
          translatedPhrase = this.langData[key];
        } else {

          this.services.logger.warning(`Missing translation for ${key} in language ${this.services.language.currentLanguage}`);

          return key;
        }
      }
      return this._resolveBraces(translatedPhrase, parameters);
    } catch (err) {
      console.log('error in transform  function, error message: ', err);
      return '';
    }
  }

  getTranslation(key: string, parameters?: any): TextTranslation {
    return new TextTranslation(this, key,  parameters);
  }

  private _resolveBraces(str: string, value = null) {

    if('' === str)
      return str;

    if (Check.isObject(value)) {
        Object.keys(value).forEach(key => str = str.replace(`{${key}}`, value[key]));
    }
    else {

      let objectKeys = str.match(/[^{]+(?=\})/g) || []; //array of object keys that have to be replaced (looking for {foo})

      for (let objectKey of objectKeys) {
        if (value) {
          str = str.replace(`{${objectKey}}`, value);
        } else {
          //if we didn't get value we will look the key in the config
          str = str.replace(`{${objectKey}}`, this.services.configuration.resolveConfigurationValue(objectKey));
        }
      }

    }
      return str;

  }
}
